import { headers as natsHeaders, nuid } from "nats.ws";
import type { MsgHdrs } from "nats.ws";

import type { CallHeaders } from "../context";

export function toNatsHeaders(headers: CallHeaders): MsgHdrs {
  const callHeaders = natsHeaders();
  callHeaders.append("correlation-id", headers.correlationId);
  callHeaders.append("client-id", headers.clientId);
  callHeaders.append("issued-at", headers.issuedAt);
  return callHeaders;
}

// MsgHdrs.get returns "" for an absent key, hence `||` rather than `??`.
export function fromNatsHeaders(headers: MsgHdrs | undefined): CallHeaders {
  return {
    correlationId: headers?.get("correlation-id") || `X${nuid.next()}`,
    clientId: headers?.get("client-id") || "<unknown client_id>",
    issuedAt: headers?.get("issued-at") || "<no issue time>",
  };
}
